import dayjs from 'dayjs';

/**
 * Parses API datetime values consistently.
 * Supports ISO-8601 (2026-05-25T06:12:14.000000Z) and legacy "Y-m-d H:i:s" (UTC in DB).
 */
export function parseApiDateTime(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  var str = String(value).trim();
  if (!str) {
    return null;
  }

  if (str.indexOf('T') !== -1) {
    var parsedIso = dayjs(str);
    return parsedIso.isValid() ? parsedIso : null;
  }

  var parsedLegacy = dayjs(str.replace(' ', 'T') + 'Z');
  return parsedLegacy.isValid() ? parsedLegacy : null;
}
